/**
 * `StaffRole` e `ActorKind` — CONTRACTS §2.7.
 *
 * Enum unico, em `packages/domain`, importado pelo Prisma e pelo `packages/security`.
 * `COURIER` e a grafia canonica do papel que o DATA_MODEL chamava `DELIVERY`.
 * `CUSTOMER`, `SYSTEM` e `INTEGRATION` **nao** sao `StaffRole`: sao `ActorKind`.
 */

export const STAFF_ROLES = [
  'STORE_OPERATOR',
  'STORE_MANAGER',
  'PHARMACIST',
  'CATALOG_CURATOR',
  'COURIER',
  'NETWORK_ADMIN',
  'INTEGRATION_ADMIN',
  'DPO',
] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

/** CONTRACTS §2.7 — `COURIER` e o unico papel previsto (fase 2); no MVP o operador confirma. */
export const MVP_STAFF_ROLES = [
  'STORE_OPERATOR',
  'STORE_MANAGER',
  'PHARMACIST',
  'CATALOG_CURATOR',
  'NETWORK_ADMIN',
  'INTEGRATION_ADMIN',
  'DPO',
] as const satisfies readonly StaffRole[];

export const ACTOR_KINDS = ['CUSTOMER', 'STAFF', 'SYSTEM', 'COURIER', 'INTEGRATION'] as const;

export type ActorKind = (typeof ACTOR_KINDS)[number];

export type Actor =
  | { readonly kind: 'CUSTOMER'; readonly customerId?: string }
  | {
      readonly kind: 'STAFF';
      readonly role: StaffRole;
      readonly staffId?: string;
      readonly storeId?: string;
    }
  | { readonly kind: 'COURIER'; readonly courierId?: string }
  | { readonly kind: 'SYSTEM' }
  | { readonly kind: 'INTEGRATION' };

const CONJUNTO_PAPEIS: ReadonlySet<string> = new Set<string>(STAFF_ROLES);

export function isStaffRole(value: unknown): value is StaffRole {
  return typeof value === 'string' && CONJUNTO_PAPEIS.has(value);
}

export function hasStaffRole(actor: Actor, roles: readonly StaffRole[]): boolean {
  return actor.kind === 'STAFF' && roles.includes(actor.role);
}

/** Rotulo estavel para trilha de auditoria e mensagem de erro. */
export function actorLabel(actor: Actor): string {
  return actor.kind === 'STAFF' ? `STAFF:${actor.role}` : actor.kind;
}

export const CUSTOMER_ACTOR: Actor = { kind: 'CUSTOMER' };
export const SYSTEM_ACTOR: Actor = { kind: 'SYSTEM' };

export function staffActor(role: StaffRole): Actor {
  return { kind: 'STAFF', role };
}
